//==================================================================//
//======================= IMPORTS API ==============================//
//==================================================================//

import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import View from "../View.mjs";

//==================================================================//
//===================== IMPORTS SERVICES ===========================//
//==================================================================//

import ColaboradorService from "./ColaboradorService";
import ContasAPagarService from "./ContasAPagarService";

//==================================================================//
//====================== IMPORTS UTILS =============================//
//==================================================================//

import UtilDateTime from "@/utils/UtilDateTime";
import UtilArray from "@/utils/UtilArray.mjs";
import UtilObject from "@/utils/UtilObject";
import UtilNumber from "@/utils/UtilNumber";
import OrdemDePagamentoParcelasService from "./OrdemDePagamentoParcelasService";

//==================================================================//
//===================== ADMIN ID & OWNER ===========================//
//==================================================================//

const ADMIN_OWNER = "23e308ed-4f67-4394-9a77-7228d2992dc3";
const ADMIN_ID = "9a405812-b83c-4b9f-8ad3-68c91a33725a";

//==================================================================//
//===================== ADMIN ID & OWNER ===========================//
//==================================================================//

const FILIAL_DELTA_DUCON_ID = "c511a33d-6b85-4cdf-88af-6a221f0eb46d";

//==================================================================//
//========================= METHODS ================================//
//==================================================================//

export default {

    async pegaViewOrdemDePagamentoAprovadoresPegaAprovadoresDoRequisitante(requisitanteID){

        let aprovadoresDoRequisitante;

        try{

            //==================================================================//
            //================ PEGA GRUPO DO REQUISITANTE ======================//
            //==================================================================//

            let requisitanteGrupo = await ColaboradorService.pegaColaboradorGrupo(requisitanteID);
            if(requisitanteGrupo.status != 200){
                throw requisitanteGrupo;
            }

            let requisitanteGrupoID = requisitanteGrupo?.data?.id || "";

            //==================================================================//
            //============== Pega Ordem de Pagamento Requisitantes =============//
            //==================================================================//

            aprovadoresDoRequisitante = await ERP.getOneWithView(View.ORDEM_DE_PAGAMENTO_APROVADORES_PEGA_APROVADORES_DO_REQUISITANTE,[
                {
                    name: "grupoID",
                    dataType: "String",
                    value: requisitanteGrupoID
                },
            ]);

        }catch(e){

            console.log(e);
            return aprovadoresDoRequisitante;

        }

        return aprovadoresDoRequisitante;

    },

    async criaAprovador(aprovadorValores = {}){

        let ordemDePagamentoAprovador;

        try{

            //==================================================================//
            //====================== PREPARO DOS VALORES =======================//
            //==================================================================//

            aprovadorValores = {
                status: aprovadorValores?.status || "Valido",
                aprovadorTipo: aprovadorValores?.aprovadorTipo || "Nenhum",
                aprovador: aprovadorValores?.aprovador || "",
                decisao: aprovadorValores?.decisao || "A decidir",
            };

            //==================================================================//
            //================= CRIA APROVADOR ORDEM DE PAGAMENTO =============//
            //==================================================================//

            ordemDePagamentoAprovador = await ERP.postOne(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, aprovadorValores);
            if(ordemDePagamentoAprovador.status != 200){
                throw ordemDePagamentoAprovador;
            }

            console.log(ordemDePagamentoAprovador);

        }catch(e){

            console.log(e);
            return ordemDePagamentoAprovador;

        }

        return ordemDePagamentoAprovador;

    },

    async criaAprovadores(aprovadoresValores = []){

        let ordemDePagamentoAprovadores;

        try{

            //==================================================================//
            //====================== PREPARO DOS VALORES =======================//
            //==================================================================//

            aprovadoresValores = aprovadoresValores.map((aprovador = {}) => ({
                status: aprovador?.status || "Valido",
                aprovadorTipo: aprovador?.aprovadorTipo || "Nenhum",
                aprovador: aprovador?.aprovador || "",
                decisao: aprovador?.decisao || "A decidir",
            }));

            //==================================================================//
            //================ CRIA APROVADORES ORDEM DE PAGAMENTO ============//
            //==================================================================//

            ordemDePagamentoAprovadores = await ERP.postMany(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, aprovadoresValores);
            if(ordemDePagamentoAprovadores.status != 200){
                throw ordemDePagamentoAprovadores;
            }

            console.log(ordemDePagamentoAprovadores);

        }catch(e){

            console.log(e);
            return ordemDePagamentoAprovadores;

        }

        return ordemDePagamentoAprovadores;

    },

    async alteraAprovador(aprovadorValores = {}){

        let ordemDePagamentoAprovador;

        try{

            //==================================================================//
            //================ ALTERA APROVADOR ORDEM DE PAGAMENTO ============//
            //==================================================================//

            ordemDePagamentoAprovador = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, aprovadorValores);
            if(ordemDePagamentoAprovador.status != 200){
                throw ordemDePagamentoAprovador;
            }

            console.log(ordemDePagamentoAprovador);

        }catch(e){

            console.log(e);
            return ordemDePagamentoAprovador;

        }

        return ordemDePagamentoAprovador;

    },

    async alteraAprovadores(aprovadoresValores = []){

        let ordemDePagamentoAprovadores;

        try{

            //==================================================================//
            //=============== ALTERA APROVADORES ORDEM DE PAGAMENTO ===========//
            //==================================================================//

            ordemDePagamentoAprovadores = await ERP.patchMany(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, aprovadoresValores);
            if(ordemDePagamentoAprovadores.status != 200){
                throw ordemDePagamentoAprovadores;
            }

            console.log(ordemDePagamentoAprovadores);

        }catch(e){

            console.log(e);
            return ordemDePagamentoAprovadores;

        }

        return ordemDePagamentoAprovadores;

    },

    async executaReprovacao(reprovadorValores = {}){

        let ordemDePagamentoReprovacao;

        try{

            let ordemDePagamentoReprovacaoID = reprovadorValores?.id;

            //==================================================================//
            //=================== PEGA ORDEM DE PAGAMENTO ======================//
            //==================================================================//

            let ordemDePagamento = await ERP.getOneByValue(Schema.ORDEM_DE_PAGAMENTO,"aprovadores", ordemDePagamentoReprovacaoID);
            if(ordemDePagamento?.status != 200){
                throw ordemDePagamento;
            }

            console.log(ordemDePagamento);

            //==================================================================//
            //======================== PEGA APROVACOES =========================//
            //==================================================================//

            let aprovadoresIDs = ordemDePagamento?.data?.aprovadores || [];

            let ordemDePagamentoAprovadores = await ERP.getManyById(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, aprovadoresIDs);
            if(ordemDePagamentoAprovadores?.status != 200){
                throw ordemDePagamentoAprovadores;
            }

            console.log(ordemDePagamentoAprovadores);

            //==================================================================//
            //===================== EXECUTA REPROVACAO =========================//
            //==================================================================//

            let ordemDePagamentoReprovacaoValores = {
                id: ordemDePagamentoReprovacaoID || "",
                decisao: "Reprovou",
                justificativa: reprovadorValores?.justificativa || "",
                dataDecisao: UtilDateTime.todayUTC(),
            }

            ordemDePagamentoReprovacao = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, ordemDePagamentoReprovacaoValores);
            if(ordemDePagamentoReprovacao?.status != 200){
                throw ordemDePagamentoReprovacao;
            }

            console.log(ordemDePagamentoReprovacao);

            //==================================================================//
            //=============== PEGA APROVADORES REQUISITANTES ===================//
            //==================================================================//

            const aprovadoresRequisitantes = ordemDePagamentoAprovadores?.data?.filter(aprovador => (
                aprovador?.aprovadorTipo === "Requisitante" && 
                aprovador?.id !== ordemDePagamentoReprovacaoID
            )) || [];

            //==================================================================//
            //=============== PEGA APROVADORES COORDENADORES ===================//
            //==================================================================//

            const aprovadoresCoordenadores = ordemDePagamentoAprovadores?.data?.filter(aprovador => (
                aprovador?.aprovadorTipo === "Coordenador" &&
                aprovador?.id !== ordemDePagamentoReprovacaoID
            )) || [];
            
            //==================================================================//
            //================= PEGA APROVADORES GESTORES ======================//
            //==================================================================//

            const aprovadoresGestores = ordemDePagamentoAprovadores?.data?.filter(aprovador => (
                aprovador?.aprovadorTipo === "Gestor" &&
                aprovador?.id !== ordemDePagamentoReprovacaoID
            )) || [];

            //==================================================================//
            //================ PEGA APROVADORES FINANCEIROS ====================//
            //==================================================================//

            const aprovadoresFinanceiros = ordemDePagamentoAprovadores?.data?.filter(aprovador => (
                aprovador?.aprovadorTipo === "Financeiro" &&
                aprovador?.id !== ordemDePagamentoReprovacaoID
            )) || [];

            //==================================================================//
            //================ PEGA APROVADORES REMANESCENTES ==================//
            //==================================================================//

            let aprovadoresParaCancelar = [];
            let aprovadoresParaPermanescer = [];
            let ordemDePagamentoReprovacaoTipo = ordemDePagamentoReprovacao?.data?.aprovadorTipo;

            if(ordemDePagamentoReprovacaoTipo == "Requisitante"){
                
                aprovadoresParaCancelar = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ...aprovadoresCoordenadores,
                    ...aprovadoresGestores,
                    ...aprovadoresFinanceiros,
                ]);

                aprovadoresParaPermanescer = UtilArray.concat([
                    ordemDePagamentoReprovacao.data
                ]);

            }

            if(ordemDePagamentoReprovacaoTipo == "Coordenador"){
                
                aprovadoresParaCancelar = UtilArray.concat([
                    ...aprovadoresCoordenadores,
                    ...aprovadoresGestores,
                    ...aprovadoresFinanceiros,
                ]);

                aprovadoresParaPermanescer = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ordemDePagamentoReprovacao.data
                ]);

            }

            if(ordemDePagamentoReprovacaoTipo == "Gestor"){
                
                aprovadoresParaCancelar = UtilArray.concat([
                    ...aprovadoresGestores,
                    ...aprovadoresFinanceiros,
                ]);

                aprovadoresParaPermanescer = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ...aprovadoresCoordenadores,
                    ordemDePagamentoReprovacao.data
                ]);

            }

            if(ordemDePagamentoReprovacaoTipo == "Financeiro"){
                
                aprovadoresParaCancelar = UtilArray.concat([
                    ...aprovadoresFinanceiros,
                ]);

                aprovadoresParaPermanescer = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ...aprovadoresCoordenadores,
                    ...aprovadoresGestores,
                    ordemDePagamentoReprovacao.data
                ]);

            }

            console.log({
                log:"Aprovadores para Cancelar",
                aprovadoresParaCancelar
            });

            console.log({
                log:"Aprovadores para Permanecer",
                aprovadoresParaPermanescer
            });

            //==================================================================//
            //====================== EXECUTA CANCELAMENTOS =====================//
            //==================================================================//

            if(UtilArray.isNotEmpty(aprovadoresParaCancelar)){

                let aprovadoresParaCancelarIDs = aprovadoresParaCancelar?.map(({ id }) => id) || [];

                let aprovadoresCancelados = await this.executaCancelamentos(aprovadoresParaCancelarIDs);
                if(aprovadoresCancelados?.status != 200){
                    throw aprovadoresCancelados;
                }

            }

            //==================================================================//
            //============= PREPARA APROVADORES PARA PERMANECER IDS ============//
            //==================================================================//

            let aprovadoresParaPermanescerIDs = aprovadoresParaPermanescer?.map(({ id }) => id) || [];

            //==================================================================//
            //===================== PEGA OWNER DO EMITENTE =====================//
            //==================================================================//

            let emitenteID = ordemDePagamento?.data?.emitente;

            let emitenteUsuario = await ColaboradorService.pegaColaboradorUsuario(emitenteID);
            if(emitenteUsuario?.status != 200){
                throw emitenteUsuario;
            }

            let emitenteOwner = emitenteUsuario?.data;

            //==================================================================//
            //========================== PREPARA OWNERS ========================//
            //==================================================================//

            let ordemDePagamentoOwners = UtilArray.unique([ADMIN_OWNER,emitenteOwner]);

            console.log({
                log: "Ordem de Pagamento Owners",
                ordemDePagamentoOwners
            });

            //==================================================================//
            //===================== ALTERA ORDEM DE PAGAMENTO ==================//
            //==================================================================//

            let ordemDePagamentoValores = {
                id: ordemDePagamento?.data?.id || "",
                status: "Elaboração",
                owners: ordemDePagamentoOwners || [],
                aprovadores: aprovadoresParaPermanescerIDs
            }

            ordemDePagamento = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoValores);
            if(ordemDePagamento.status != 200){
                throw ordemDePagamento;
            }

            console.log(ordemDePagamento);

        }catch(e){

            console.log(e);
            return ordemDePagamentoReprovacao;

        }

        return ordemDePagamentoReprovacao;

    },

    async executaAprovacao(aprovadorValores = {}){

        let ordemDePagamentoAprovacao;

        try{

            let ordemDePagamentoAprovacaoID = aprovadorValores?.id;

            //==================================================================//
            //=================== PEGA ORDEM DE PAGAMENTO ======================//
            //==================================================================//

            let ordemDePagamento = await ERP.getOneByValue(Schema.ORDEM_DE_PAGAMENTO,"aprovadores", ordemDePagamentoAprovacaoID);
            if(ordemDePagamento?.status != 200){
                throw ordemDePagamento;
            }

            console.log(ordemDePagamento);

            //==================================================================//
            //======================== PEGA APROVACOES =========================//
            //==================================================================//

            let aprovadoresIDs = ordemDePagamento?.data?.aprovadores || [];

            let ordemDePagamentoAprovadores = await ERP.getManyById(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, aprovadoresIDs);
            if(ordemDePagamentoAprovadores?.status != 200){
                throw ordemDePagamentoAprovadores;
            }

            console.log(ordemDePagamentoAprovadores);

            //==================================================================//
            //====================== EXECUTA APROVACAO =========================//
            //==================================================================//

            let ordemDePagamentoAprovacaoValores = {
                id: ordemDePagamentoAprovacaoID || "",
                decisao: "Aprovou",
                justificativa: aprovadorValores?.justificativa || "",
                dataDecisao: UtilDateTime.todayUTC(),
            }

            ordemDePagamentoAprovacao = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, ordemDePagamentoAprovacaoValores);
            if(ordemDePagamentoAprovacao?.status != 200){
                throw ordemDePagamentoAprovacao;
            }

            console.log(ordemDePagamentoAprovacao);

            //==================================================================//
            //=============== PEGA APROVADORES REQUISITANTES ===================//
            //==================================================================//

            const aprovadoresRequisitantes = ordemDePagamentoAprovadores?.data?.filter(aprovador => (
                aprovador?.aprovadorTipo === "Requisitante" && 
                aprovador?.id !== ordemDePagamentoAprovacaoID
            )) || [];

            //==================================================================//
            //=============== PEGA APROVADORES COORDENADORES ===================//
            //==================================================================//

            const aprovadoresCoordenadores = ordemDePagamentoAprovadores?.data?.filter(aprovador => (
                aprovador?.aprovadorTipo === "Coordenador" &&
                aprovador?.id !== ordemDePagamentoAprovacaoID
            )) || [];
            
            //==================================================================//
            //================= PEGA APROVADORES GESTORES ======================//
            //==================================================================//

            const aprovadoresGestores = ordemDePagamentoAprovadores?.data?.filter(aprovador => (
                aprovador?.aprovadorTipo === "Gestor" &&
                aprovador?.id !== ordemDePagamentoAprovacaoID
            )) || [];

            //==================================================================//
            //================ PEGA APROVADORES FINANCEIROS ====================//
            //==================================================================//

            const aprovadoresFinanceiros = ordemDePagamentoAprovadores?.data?.filter(aprovador => (
                aprovador?.aprovadorTipo === "Financeiro" &&
                aprovador?.id !== ordemDePagamentoAprovacaoID
            )) || [];

            //==================================================================//
            //================ PEGA APROVADORES REMANESCENTES ==================//
            //==================================================================//

            let ordemDePagamentoAprovacaoTipo = ordemDePagamentoAprovacao?.data?.aprovadorTipo;
            let ordemDePagamentoProximoStatus = "Elaboração";
            let aprovadoresParaCancelar = [];
            let aprovadoresParaPermanescer = [];
            let aprovadoresComAcesso = [];

            if(ordemDePagamentoAprovacaoTipo == "Requisitante"){
                
                ordemDePagamentoProximoStatus = "Aguardando Coordenador";

                aprovadoresParaCancelar = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                ]);

                aprovadoresParaPermanescer = UtilArray.concat([
                    ordemDePagamentoAprovacao.data,
                    ...aprovadoresCoordenadores,
                    ...aprovadoresGestores,
                    ...aprovadoresFinanceiros,
                ]);

                aprovadoresComAcesso = UtilArray.concat([
                    ordemDePagamentoAprovacao.data,
                    ...aprovadoresCoordenadores,
                ]);

            }

            if(ordemDePagamentoAprovacaoTipo == "Coordenador"){

                ordemDePagamentoProximoStatus = "Aguardando Gestor";
                
                aprovadoresParaCancelar = UtilArray.concat([
                    ...aprovadoresCoordenadores,
                ]);

                aprovadoresParaPermanescer = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ordemDePagamentoAprovacao.data,
                    ...aprovadoresGestores,
                    ...aprovadoresFinanceiros,
                ]);

                aprovadoresComAcesso = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ordemDePagamentoAprovacao.data,
                    ...aprovadoresGestores,
                ]);

            }

            if(ordemDePagamentoAprovacaoTipo == "Gestor"){

                ordemDePagamentoProximoStatus = "Aguardando Financeiro";
                
                aprovadoresParaCancelar = UtilArray.concat([
                    ...aprovadoresGestores,
                ]);

                aprovadoresParaPermanescer = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ...aprovadoresCoordenadores,
                    ordemDePagamentoAprovacao.data,
                    ...aprovadoresFinanceiros,
                ]);

                aprovadoresComAcesso = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ...aprovadoresCoordenadores,
                    ordemDePagamentoAprovacao.data,
                    ...aprovadoresFinanceiros,
                ]);

            }

            if(ordemDePagamentoAprovacaoTipo == "Financeiro"){

                ordemDePagamentoProximoStatus = "Aprovado";
                
                aprovadoresParaCancelar = UtilArray.concat([
                    ...aprovadoresFinanceiros,
                ]);

                aprovadoresParaPermanescer = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ...aprovadoresCoordenadores,
                    ...aprovadoresGestores,
                    ordemDePagamentoAprovacao.data
                ]);

                aprovadoresComAcesso = UtilArray.concat([
                    ...aprovadoresRequisitantes,
                    ...aprovadoresCoordenadores,
                    ...aprovadoresGestores,
                    ordemDePagamentoAprovacao.data,
                ]);

            }

            console.log({
                log:"Aprovadores para Cancelar",
                aprovadoresParaCancelar
            });

            console.log({
                log:"Aprovadores para Permanecer",
                aprovadoresParaPermanescer
            });

            //==================================================================//
            //====================== EXECUTA CANCELAMENTOS =====================//
            //==================================================================//

            if(UtilArray.isNotEmpty(aprovadoresParaCancelar)){

                let aprovadoresParaCancelarIDs = aprovadoresParaCancelar?.map(({ id }) => id) || [];

                let aprovadoresCancelados = await this.executaCancelamentos(aprovadoresParaCancelarIDs);
                if(aprovadoresCancelados?.status != 200){
                    throw aprovadoresCancelados;
                }

            }

            //==================================================================//
            //============= PREPARA APROVADORES PARA PERMANECER IDS ============//
            //==================================================================//

            let aprovadoresParaPermanescerIDs = aprovadoresParaPermanescer?.map(({ id }) => id) || [];

            //==================================================================//
            //===================== PEGA OWNER DO EMITENTE =====================//
            //==================================================================//

            let emitenteID = ordemDePagamento?.data?.emitente;

            let emitenteUsuario = await ColaboradorService.pegaColaboradorUsuario(emitenteID);
            if(emitenteUsuario?.status != 200){
                throw emitenteUsuario;
            }

            let emitenteOwner = emitenteUsuario?.data;

            //==================================================================//
            //============= PEGA OWNER DOS APROVADORES COM ACESSO ==============//
            //==================================================================//

            let aprovacoesComAcessoIDs = aprovadoresComAcesso?.map(({ aprovador }) => aprovador) || [];

            let aprovacoesComAcessoUsuario = await ColaboradorService.pegaColaboradoresUsuario(aprovacoesComAcessoIDs);
            if(aprovacoesComAcessoUsuario?.status != 200){
                throw aprovacoesComAcessoUsuario;
            }

            let aprovadoresComAcessoOwners = aprovacoesComAcessoUsuario?.data || [];

            //==================================================================//
            //========================== PREPARA OWNERS ========================//
            //==================================================================//

            let ordemDePagamentoOwners = UtilArray.unique([ADMIN_OWNER,emitenteOwner,...aprovadoresComAcessoOwners]);

            console.log({
                log: "Ordem de Pagamento Owners",
                ordemDePagamentoOwners
            });

            //==================================================================//
            //===================== ALTERA ORDEM DE PAGAMENTO ==================//
            //==================================================================//

            let ordemDePagamentoValores = {
                id: ordemDePagamento?.data?.id || "",
                status: ordemDePagamentoProximoStatus,
                owners: ordemDePagamentoOwners || [],
                aprovadores: aprovadoresParaPermanescerIDs
            }

            if(ordemDePagamentoProximoStatus == "Aprovado"){
                ordemDePagamentoValores.dataAprovacaoPagamento = UtilDateTime.todayISO();
            }

            ordemDePagamento = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoValores);
            if(ordemDePagamento.status != 200){
                throw ordemDePagamento;
            }

            console.log(ordemDePagamento);

            //==================================================================//
            //======= APENAS QUANDO ORDEM DE PAGAMENTO STATUS: "APROVADO" ======//
            //==================================================================//

            if(ordemDePagamentoProximoStatus == "Aprovado"){

                //==================================================================//
                //================ PEGA PARCELAS DA ORDEM DE PAGAMENTO =============//
                //==================================================================//

                let parcelasIDs = ordemDePagamento?.data?.parcelas || [];

                let ordemDePagamentoParcelas = await ERP.getManyById(Schema.ORDEM_DE_PAGAMENTO_PARCELAS, parcelasIDs);
                if(ordemDePagamentoParcelas.status != 200){
                    throw new Error("Falha em pegar as Parcelas da Ordem de Pagamento para Criar Contas a Pagar");
                }

                console.log(ordemDePagamentoParcelas);
                
                //==================================================================//
                //=== CRIA AS CONTAS A PAGAR DAS PARCELAS DA ORDEM DE PAGAMENTO ====//
                //==================================================================//
        
                let contasAPagarValores = ordemDePagamentoParcelas.data.map((parcela,index)=>{
                
                    return {
                        origem: "Ordem de Pagamento",
                        pagamentoForma: ordemDePagamento?.data?.formaDePagamento || "",
                        pagamentoTipo: parcela?.tipo || "",
                        pagamentoEvento: "C/Ordem de pagamento",
                        descricao: parcela?.descricao || "",
                        sequencia: index + 1 || "",
                        filial: FILIAL_DELTA_DUCON_ID || "",
                        status: "Prevista",
                        ordemDePagamento: ordemDePagamento?.data?.id || "",
                        ordemDePagamentoParcela: parcela?.id || "",
                        favorecidoColaborador: ordemDePagamento?.data?.credorColaborador || null,
                        favorecidoFornecedor: ordemDePagamento?.data?.credorFornecedor || null,
                        dataVencimento: parcela?.dataDoPagamento || "",
                        valorOriginal: UtilNumber.round(parcela?.valor),
                        valorParaReservar: UtilNumber.round(parcela?.valor),
                        valorDesconto: 0,
                        valorPagamento: 0,
                        valorReservado: 0,
                        valorParaPagar: 0,
                        valorPago: 0,
                        valorParaVincular: 0,
                        valorVinculado: 0,
                    }

                });

                let contaAPagar = await ContasAPagarService.criarContasAPagar(contasAPagarValores);
                if(contaAPagar.status != 200){
                    throw new Error("Falha em criar as Contas a Pagar das Parcelas de Ordem de Pagamento");
                }

                console.log(contaAPagar);

                //==================================================================//
                //==== VINCULA CONTA A PAGAR A PARCELA DE ORDEM DE PAGAMENTO =======//
                //==================================================================//

                let ordemDePagamentoParcelasValores = contaAPagar.data.map((contaAPagar)=>{

                    return{
                        id: contaAPagar.ordemDePagamentoParcela,
                        contaAPagar: contaAPagar.id
                    }

                });
    
                ordemDePagamentoParcelas = await OrdemDePagamentoParcelasService.alteraParcelas(ordemDePagamentoParcelasValores);
                if(ordemDePagamentoParcelas.status != 200){
                    throw new Error("Falha em relacionar as Contas a Pagar com suas respectivas Parcelas da Ordem de Pagamento");
                }

            }

        }catch(e){

            console.log(e);
            return ordemDePagamentoAprovacao;

        }

        return ordemDePagamentoAprovacao;

    },

    async executaCancelamento(cancelamentoValor = ""){

        let cancelamento;

        try{

            //==================================================================//
            //====================== EXECUTA CANCELAMENTO ======================//
            //==================================================================//

            cancelamentoValor = {
                id: cancelamentoValor,
                status: "Cancelado",
                decisao: "Nula",
                dataDecisao: UtilDateTime.todayUTC(),
            }

            cancelamento = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, cancelamentoValor);
            if(cancelamento?.status != 200){
                throw cancelamento;
            }

            console.log(cancelamento);

        }catch(e){

            console.log(e);
            return cancelamento;

        }

        return cancelamento;

    },

    async executaCancelamentos(cancelamentosValores = []){

        let cancelamentos;

        try{

            //==================================================================//
            //===================== EXECUTA CANCELAMENTOS ======================//
            //==================================================================//

            cancelamentosValores = cancelamentosValores.map((cancelamentoValor = "") => {

                return {
                    id: cancelamentoValor || "",
                    status: "Cancelado",
                    decisao: "Nula",
                    dataDecisao: UtilDateTime.todayUTC(),
                };

            });

            cancelamentos = await ERP.patchMany(Schema.ORDEM_DE_PAGAMENTO_APROVADORES, cancelamentosValores);
            if(cancelamentos?.status != 200){
                throw cancelamentos;
            }

            console.log(cancelamentos);

        }catch(e){

            console.log(e);
            return cancelamentos;

        }

        return cancelamentos;

    },

    async pegaAprovadores(requisitanteID = ""){

        let aprovadoresDoRequisitante;

        try{

            //==================================================================//
            //============= PEGA APROVADORES DO REQUISITANTE ===================//
            //==================================================================//

            aprovadoresDoRequisitante = await this.pegaViewOrdemDePagamentoAprovadoresPegaAprovadoresDoRequisitante(requisitanteID);
            if(aprovadoresDoRequisitante?.status != 200){
                throw aprovadoresDoRequisitante;
            }

            //==================================================================//
            //========= INICIALIZA CADA TIPO DE APROVADORES DO CREDOR ==========//
            //==================================================================//

            let aprovadoresRequisitantes = [];
            let aprovadoresCoordenadores = aprovadoresDoRequisitante?.data?.coordenadores || [];
            let aprovadoresGestores = aprovadoresDoRequisitante?.data?.gestores || [];
            let aprovadoresFinanceiros = aprovadoresDoRequisitante?.data?.financeiros || [];

            //==================================================================//
            //===================== PREPARA REQUISITANTE =======================//
            //==================================================================//

            aprovadoresRequisitantes.push({
                aprovadorTipo: "Requisitante",
                aprovador: requisitanteID || ADMIN_ID,
            });

            //==================================================================//
            //==================== PREPARA COORDENADORES =======================//
            //==================================================================//

            aprovadoresCoordenadores = aprovadoresCoordenadores.map((aprovador) => ({
                aprovadorTipo: "Coordenador",
                aprovador: aprovador?.id || ADMIN_ID,
            }));

            //==================================================================//
            //====================== PREPARA GESTORES ==========================//
            //==================================================================//

            aprovadoresGestores = aprovadoresGestores.map((aprovador) => ({
                aprovadorTipo: "Gestor",
                aprovador: aprovador?.id || ADMIN_ID,
            }));

            //==================================================================//
            //====================== PREPARA FINANCEIROS =======================//
            //==================================================================//

            aprovadoresFinanceiros = aprovadoresFinanceiros.map((aprovador) => ({
                aprovadorTipo: "Financeiro",
                aprovador: aprovador?.id || ADMIN_ID,
            }));

            //==================================================================//
            //==================== DEFAULT COORDENADORES =======================//
            //==================================================================//
            // Se o Credor não tiver Coordenadores.
            // O Administrador será utilizado como Coordenador.

            if(UtilArray.isEmpty(aprovadoresCoordenadores)){

                aprovadoresCoordenadores = [
                    {
                        aprovadorTipo: "Coordenador",
                        aprovador: ADMIN_ID,
                    },
                ]

            }

            //==================================================================//
            //====================== DEFAULT GESTORES ==========================//
            //==================================================================//
            // Se o Credor não tiver Gestores.
            // O Administrador será utilizado como Coordenador.

            if(UtilArray.isEmpty(aprovadoresGestores)){

                aprovadoresGestores = [
                    {
                        aprovadorTipo: "Gestor",
                        aprovador: ADMIN_ID,
                    },
                ]

            }

            //==================================================================//
            //===================== DEFAULT FINANCEIROS ========================//
            //==================================================================//
            // Se o Credor não tiver Financeiros.
            // O Administrador será utilizado como Coordenador.

            if(UtilArray.isEmpty(aprovadoresFinanceiros)){

                aprovadoresFinanceiros = [
                    {
                        aprovadorTipo: "Financeiro",
                        aprovador: ADMIN_ID,
                    },
                ]

            }

            //==================================================================//
            //========= INICIALIZA APROVADORES DA ORDEM DE PAGAMENTO ===========//
            //========== CONCATENA APROVADORES DA ORDEM DE PAGAMENTO ===========//
            //==================================================================//

            let aprovadoresDaOrdemDePagamento = UtilArray.concat(
                aprovadoresRequisitantes,
                aprovadoresCoordenadores,
                aprovadoresGestores,
                aprovadoresFinanceiros
            );

            aprovadoresDoRequisitante = UtilObject.clone(aprovadoresDoRequisitante);

            aprovadoresDoRequisitante.data = aprovadoresDaOrdemDePagamento || [];

            console.log(aprovadoresDoRequisitante);

        }catch(e){

            console.log(e);
            return aprovadoresDoRequisitante;

        }

        return aprovadoresDoRequisitante;

    },

    async criarAprovadoresParaOrdemDePagamento(ordemDePagamentoID){

        let ordemDePagamentoAprovadores;

        try{

            //==================================================================//
            //==================== GET ORDEM DE PAGAMENTO ======================//
            //==================================================================//

            const ordemDePagamento = await ERP.getOneById(Schema.ORDEM_DE_PAGAMENTO, ordemDePagamentoID);
            if(ordemDePagamento.status !== 200){
                throw ordemDePagamento;
            }

            //==================================================================//
            //========== PREPARA REQUISITANTE PARA PEGAR APROVAÇÕES ============//
            //==================================================================//

            let requisitanteID = ordemDePagamento?.data?.requisitante || "";

            ordemDePagamentoAprovadores = await this.pegaAprovadores(requisitanteID);
            if(ordemDePagamentoAprovadores?.status != 200){
                throw ordemDePagamentoAprovadores;
            }

            //==================================================================//
            //============ CRIA APROVADORES PARA ORDEM DE PAGAMENTO ============//
            //==================================================================//

            let ordemDePagamentoAprovadoresValores = ordemDePagamentoAprovadores.data || [];

            ordemDePagamentoAprovadores = await this.criaAprovadores(ordemDePagamentoAprovadoresValores);
            if(ordemDePagamentoAprovadores?.status != 200){
                throw ordemDePagamentoAprovadores;
            }

        }catch(e){

            console.log(e);
            return ordemDePagamentoAprovadores;

        }

        return ordemDePagamentoAprovadores;

    },

}